import { TimerRedirectTo } from 'components/timers'
import { Loading } from 'components/ui'
import { CreateUser } from 'modules/users/components'
import { UserEmail, UserName, UserPassword } from 'framework/users'
import { useNotification, useUserSession } from 'hooks'
import { FC, useState } from 'react'
import { UserService } from 'modules/users/services'
import type { UserCreateProps, SignUpData } from '.'

const UserCreate: FC<UserCreateProps> = ({ hasUserCreated, onCancel }) => {
  const { notify } = useNotification()
  const { setUser } = useUserSession()

  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  async function handleSignUp(data: SignUpData) {
    setLoading(true)
    try {
      const userService = new UserService()
      const {
        name,
        document,
        email,
        phone,
        password,
        birthday,
        fantasyName,
        insEstadual,
        personType,
        isExemptState,
        nameCompany,
      } = data
      const response = await userService.createUser(
        name as unknown as UserName,
        document,
        email as unknown as UserEmail,
        phone as string,
        password as unknown as UserPassword,
        birthday,
        fantasyName as string,
        insEstadual as string,
        personType as string,
        isExemptState as boolean,
        nameCompany as string,
      )

      setUser({
        id: response.data.customer.id,
        token: response.data.customer.token,
        name,
        email,
        
      })

      setSuccess(true)

      if (typeof hasUserCreated === 'function') {
        hasUserCreated()
      }
    } catch (e) {
      let message = 'Houve um erro ao criar sua conta'
      const error = e?.response?.data?.message
      if (error === 'Customer using this document already exists') {
        message = 'Esse CPF já existe, tente outro.'
      }

      if (error === 'User email already exists') {
        message = 'Esse e-mail já em uso, tente outro.'
      }

      notify({
        title: 'Atenção',
        description: message,
        type: 'danger',
      })
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <>
        Sua conta foi criada com sucesso!
        <TimerRedirectTo onFinish={onCancel} />
      </>
    )
  }

  return (
    <>
      {loading && <Loading />}
      <CreateUser onSubmit={handleSignUp} onCancel={onCancel} />
    </>
  )
}

export default UserCreate
